import React from 'react';
import './App.css';
import {Routes, Route, BrowserRouter} from 'react-router-dom';
import { SignInForm } from './Components/LoginPage/SignInForm/SignInForm';
import { Welcome } from './Components/Welcome/Welcome';
import { WelcomeBack } from './Components/WelcomeBack/WelcomeBack';
import {UsersAccount} from './Components/UsersAccount/UsersAccount';
import {Customers} from './Components/Customers/Customers';
import { GetProfile } from './Components/GetProfile/GetProfile';
import { Transactions } from './Components/Transactions/Transaction';
import { ExistingAccounts } from './Components/ExistingAccount/ExistingAccount';
import BreakPoint from './Components/BreakPoint/BreakPoint';
import OnboardUser from './Components/OnboardUser/OnboardUser';
import CreateAccount from './Components/CreateAccount/CreateAccount';
import Transaction from './Components/Transaction/Transaction';
import { Feedback } from './Components/Feedback/Feedback';
import { CustomerSummary } from './Components/CustomerSummary/CustomerSummary';
import Feedbacks from './Components/Feedbacks/Feedbacks';
import Transfer from './Components/Transfer/Transfer';
import BillPayment from './Components/BillPayment/BillPayment';
import AppToast from './ReuseComponent/Toaster/AppToast';
import Request from './Components/Request/Request';
import ErrorBoundary from './ErrorBoundary';

function App(){
 
  //const token = window.localStorage.getItem("token"); 



  return(

    <>
    
    <div className='app'> 

    <AppToast/>
    <BrowserRouter>
    
    <Routes>

      <Route path='/login' element={<SignInForm />} />

      <Route path='/welcome' element={<Welcome />} />

      <Route path='/' exact element={<WelcomeBack />} />

      <Route path='/usersaccount' element={<UsersAccount />} />

      <Route path='/customers' element={<ErrorBoundary><Customers /></ErrorBoundary>} />


      <Route path='/getProfile' element={<GetProfile />} />

      <Route path='/transactions' element={<Transactions />} />

      <Route path='/existingAccount' element={<ExistingAccounts />} />

      <Route path='/onboard' element={<OnboardUser />} />

      <Route path='/createAccount' element={<CreateAccount />} />

      <Route path='/transaction' element={<Transaction />} />

      <Route path='/customer-details' element={<CustomerSummary />} />

      <Route path='/feedback' element={<Feedback />} />

      <Route path='/feedbacks' element={<Feedbacks />} />

      <Route path='/transfer' element={<Transfer />} />

      <Route path='/bill-payment' element={<BillPayment />} />

      <Route path='/request' element={<Request />} />



  
    </Routes>

    </BrowserRouter>


    

    </div>


        <span className='break'>

            <BreakPoint />

        </span>

    </>
  
  );

}

//Prop is a property for individual components

//States


export default App;
